<template>
    <img src="@/assets/logo.png" width="20%" height="20%" />
</template>

<script>
export default {
  name: 'logo',
  props: ['light', 'konami'],
};
</script>
